import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';


export interface DropdownDto {
    businessCategories: DropdownItemDto[];
    regions: DropdownItemDto[];
    offices: DropdownItemDto[];
    groups: DropdownItemDto[];
    groupTypes: DropdownItemDto[];
    departments: DropdownItemDto[]; 
    referenceYears: DropdownItemDto[]; 
    objectiveConfigCriteriaTypes:  DropdownItemDto[]; 
    hrLevels:  DropdownItemDto[]; 
    managerTypes:  ManagerTypeDropdownItemDto[]; 
    managerTypeGroupSizes: DropdownItemDto[];
    groupSizes:  DropdownItemDto[]; 
    baseHrLevelFamilies: DropdownItemDto[];
}

export interface DropdownItemDto {
    value: number;
    parentId: number;   
    labels: DropdownLabelDto[];
}

export interface ManagerTypeDropdownItemDto extends DropdownItemDto {
    managerTypeGroupSizeIds : number[];
}

export interface DropdownLabelDto {
    language: string;
    label: string;   
}


export interface DropdownState {
    dropdowns: DropdownDto;
    gettingDropdowns: boolean;
    status: 'idle' | 'loading' | 'succeeded' | 'failed';
    error?: string;
}

const blankBusinessCategoryDto : DropdownDto ={
    businessCategories: [],
    regions: [],
    offices: [],
    groups: [],
    groupTypes: [],
    departments: [],
    referenceYears: [],
    objectiveConfigCriteriaTypes: [],
    hrLevels: [],
    managerTypes: [],
    groupSizes: [],
    baseHrLevelFamilies: [],
    managerTypeGroupSizes: []
}

const initialState: DropdownState = {
    dropdowns: blankBusinessCategoryDto,
    gettingDropdowns: false,
    status: 'idle',
    error: undefined,
};

export const dropdownSlice = createSlice({
    name: 'dropdowns',
    initialState,
    reducers: {
        clearDropdowns: (state) => {
            state.dropdowns = blankBusinessCategoryDto;
        },
    },
    extraReducers(builder) {
        builder
            .addCase(getDropdowns.pending, (state, action) => {
                state.gettingDropdowns = true;
                state.status = 'loading';
            })
            .addCase(getDropdowns.fulfilled, (state, action) => {
                state.gettingDropdowns = false;
                state.dropdowns = action.payload;
                state.status = 'succeeded';
            })
            .addCase(getDropdowns.rejected, (state, action) => {
                state.gettingDropdowns = false;
                state.dropdowns = blankBusinessCategoryDto;
                state.status = 'failed';
                state.error = action.error.message;
            });
    },
});

export const { clearDropdowns } = dropdownSlice.actions;

export const getDropdowns = createAsyncThunk('dropdowns/getDropdowns', async (referenceYear_Id: number, thunkAPI) => {
    const response = await axios.get(`/api/synergy/dropdowns/${referenceYear_Id}`);
    return response.data;
});
